import React from "react";

import { useTranslation } from "react-i18next";
import { FiEye } from "react-icons/fi";

import useSurveyStyles from "../styles";
import useStyles from "./styles";

interface Props {
  toggle?: boolean;
  actions?: (value: boolean, index?: number) => void;
}

const TabHeader: React.FC<Props> = ({ toggle, actions }) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const surveyClasses = useSurveyStyles();

  return toggle !== undefined && toggle ? (
    <div className={surveyClasses.toggleHidden}>
      <ul className={classes.tabsList}>
        <li className={classes.tabsItem} onClick={() => actions && actions(false, 0)}>
          {translate("details")}
        </li>
        <li className={classes.tabsItem} onClick={() => actions && actions(false, 1)}>
          {translate("inventory")}
        </li>
        {/** TODO Camila: wating for estimate screen to be ready */}
        {/* <li className={classes.tabsItem} onClick={() => actions && actions(false, 2)}>
          {translate("estimate")}
        </li> */}
        <li className={classes.tabsItem} onClick={() => actions && actions(false)}>
          <FiEye />
        </li>
      </ul>
    </div>
  ) : (
    <></>
  );
};

export default TabHeader;
